<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card header="Información del Tipo de Movimiento">
          <b-form>
            <b-form-group
              label="Nombre"
              label-for="nombre"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="nombre"
                v-model.trim="$v.nombre.$model" 
                :state="nombreValido"
                type="text"
                :readonly="restringido"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="nombreFeedback">
                {{ nombreInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Abreviacion"
              label-for="abreviacion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="abreviacion"
                v-model.trim="$v.abreviacion.$model" 
                :state="abreviacionValida"
                type="text"
                :readonly="restringido"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="abreviacionFeedback">
                {{ abreviacionInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <app-cuenta
              label="Cuenta"
              :nombre="cuentaNombre"
              :lista="cuentasList"
              :labelCols="labelCols"
              :nullDisabled="false"
              @updated="cuentaActualizada">
            </app-cuenta>

            <app-rubro
              label="Rubro"
              :nombre="rubroNombre"
              :lista="rubrosList"
              :labelCols="labelCols"
              :nullDisabled="false"
              :valido="rubroValido"
              :msjInvalido="rubroInvalidoMsj"
              @updated="rubroActualizado">
            </app-rubro>

            <app-subrubro
              label="Subrubro"
              :nombre="subrubroNombre"
              :lista="subrubrosList"
              :labelCols="labelCols"
              :nullDisabled="false"
              :valido="subrubroValido"
              :msjInvalido="subrubroInvalidoMsj"
              @updated="subrubroActualizado">
            </app-subrubro>  

            <b-form-group
              label="Crédito"
              label-for="credito"
              v-if="!restringido"
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="credito"
                  v-model="credito"
                  value= true
                  unchecked-value= false>
              </b-form-checkbox>
            </b-form-group>

            <b-form-group
              label="Crédito"
              label-for="creditoLabel"
              v-if="restringido"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="creditoLabel"
                :value="credito? 'Si' : 'No'"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Requiere Número"
              label-for="requiereNumero"
              v-if="!restringido"
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="requiereNumero"
                  v-model="requiereNumero"
                  value= true
                  unchecked-value= false>
              </b-form-checkbox>
            </b-form-group>

            <b-form-group
              label="Requiere Número"
              label-for="requiereNumeroLabel"
              v-if="restringido"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="requiereNumeroLabel"
                :value="requiereNumero? 'Si' : 'No'"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <app-cuenta-ingresos-gastos
              label="Cuenta"
              description="Ingresos vs Gastos"
              :nombre="cuentaIngresosGastosNombre"
              :lista="cuentasIngresosGastosList"
              :labelCols="labelCols"
              :nullDisabled="false"
              @updated="cuentaIngresosGastosActualizada">
            </app-cuenta-ingresos-gastos>

            <app-intereses-bancarios-rubros
              label="Rubro Intereses"
              description="Rubro de intereses bancarios"
              :nombre="interesBancarioRubroNombre"
              :lista="interesesBancariosRubrosList"
              :labelCols="labelCols"
              :nullDisabled="false"
              labelOption="Seleccione un rubro de intereses"
              @updated="interesBancarioRubroActualizado">
            </app-intereses-bancarios-rubros>

            <b-form-group
              label="Gasto Bancario - RN"
              label-for="gastoBancarioRN"
              :label-cols="labelCols"
              description="Gasto Bancario incluido en el cálculo de la RN"
              horizontal>
              <b-form-checkbox 
                  id="gastoBancarioRN"
                  v-model="gastoBancarioRN"
                  value= true
                  unchecked-value= false>
              </b-form-checkbox>
            </b-form-group>

            <b-form-group
              label="Inversion - RN"
              label-for="inversionRN"
              :label-cols="labelCols"
              description="Movimiento incluido como Inversión en el cálculo de la RN"
              horizontal>
              <b-form-checkbox 
                  id="inversionRN"
                  v-model="inversionRN"
                  value= true
                  unchecked-value= false>
              </b-form-checkbox>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Cuenta from '../shared/abmSelect.vue';
import Rubro from '../shared/abmSelect.vue';
import Subrubro from '../shared/abmSelect.vue';
import CuentaIngresosGastos from '../shared/abmSelect.vue';
import InteresesBancariosRubros from '../shared/abmSelect.vue';
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { required, maxLength } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'bancomovimientotipo/getField',
  mutationType: 'bancomovimientotipo/updateField',
});

export default {
  name: 'BancoMovimientoTipo',
  components: {
    appABMButton: ABMButtons,
    appCuenta: Cuenta,
    appRubro: Rubro,
    appSubrubro: Subrubro,
    appCuentaIngresosGastos: CuentaIngresosGastos,
    appInteresesBancariosRubros: InteresesBancariosRubros,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      modalMensaje: '',
      modalMsj: false,
      modalOkAction: null,
      modalHiddenAction: null,

      noValidar: true,
      nombreValido: null,
      nombreInvalidoMsj: '',
      abreviacionValida: null,
      abreviacionInvalidaMsj: '',
      cuentaValida: null,
      cuentaInvalidaMsj: '',
      rubroValido: null,
      rubroInvalidoMsj: '',
      subrubroValido: null,
      subrubroInvalidoMsj: '',
      cuentaIngresosGastosValida: null,
      cuentaIngresosGastosInvalidaMsj: '',

      cuentas: [],
      cuentasList: [],
      rubros: [],
      rubrosList: [],
      subrubros: [],
      subrubrosList: [],
      cuentasIngresosGastos: [],
      cuentasIngresosGastosList: [],
      interesesBancariosRubros: [],
      interesesBancariosRubrosList: [],

      labelCols: 2,
      loadingCuentas: false,
    }
  },
  computed: {
    ...mapFields([
      'id',
      'nombre',
      'abreviacion',
      'credito',
      'requiereNumero',
      'cuenta',
      'cuentaNombre',
      'rubro',
      'rubroNombre',
      'subrubro',
      'subrubroNombre',
      'restringido',
      'cuentaIngresosGastos',
      'cuentaIngresosGastosNombre',
      'interesBancarioRubro',
      'interesBancarioRubroNombre',
      'gastoBancarioRN',
      'inversionRN'
    ])
  },  
  created() {
    let bancoMovimientoTipoId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        bancoMovimientoTipoId = this.$route.params.id;
      }
    }

    this.loadingCuentas = true;

    this.showSpinner();
    this.$store.dispatch('bancomovimientotipo/inicializar', bancoMovimientoTipoId)
      .then(() => this.getDatosAdicionales())
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner())
  },  
  methods: {
    getDatosAdicionales() {
      const vm = this

      this.cuentas = [];
      this.cuentasList = [];
      this.$store.dispatch('cuentas/getList')
        .then(() => {
          this.cuentas = this.$store.getters['cuentas/list']
          this.cuentasList = this.$store.getters['cuentas/selectList']
          return;
        })
        .then (() => {
          this.getRubros(false);
          return;
        })
        .then (() => {
          this.getSubrubros(false);
          return;
        })
        .then(() => this.loadingCuentas = false)
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la información del plan de cuentas.'));
      
      this.$store.dispatch('cuentasIngresosGastos/getList')
        .then(() => {
          this.cuentasIngresosGastos = this.$store.getters['cuentasIngresosGastos/list']
          this.cuentasIngresosGastosList = this.$store.getters['cuentasIngresosGastos/selectList']
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar el listado de cuentas de ingresos/gastos.'));

      this.$store.dispatch('interesesBancariosRubros/getList')
        .then(() => {
          this.interesesBancariosRubros = this.$store.getters['interesesBancariosRubros/list']
          this.interesesBancariosRubrosList = this.$store.getters['interesesBancariosRubros/selectList']
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar el listado de rubros de intereses bancarios.'));

    },
    getRubros(inicializar) {
      let rubroNombre = this.rubroNombre;
      let subrubroNombre = this.subrubroNombre;
      if (inicializar) {
        rubroNombre = null;
        subrubroNombre = null;
      }

      this.rubrosList = []
      if (this.cuentaNombre) { 
        let cuenta = this.cuentas.find(cuenta => cuenta.nombre.trim() == this.cuentaNombre.trim());
        if (cuenta) {
          cuenta.rubros.forEach(rubro => {
            this.rubrosList.push(rubro.nombre);
          });
        }
      }

      this.rubroNombre = rubroNombre;
    },
    getSubrubros(inicializar) {
      let subrubroNombre = this.subrubroNombre;
      if (inicializar) {
        subrubroNombre = null;
      }

      this.subrubrosList = []
      if (this.cuentaNombre) { 
        let cuenta = this.cuentas.find(cuenta => cuenta.nombre.trim() == this.cuentaNombre.trim());
        if (cuenta) {
          if (this.rubroNombre) {
            let rubro = cuenta.rubros.find(rubro => rubro.nombre.trim() == this.rubroNombre.trim());
            if (rubro) {
              rubro.subrubros.forEach(subrubro => {
                this.subrubrosList.push(subrubro.nombre);
              });
            }
          }
        }
      }
      this.subrubroNombre = subrubroNombre;
    },

    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'nombre' || validarTodos) {
        if (this.$v.nombre.$error) {
          this.nombreValido = false;
          if (!this.$v.nombre.maxLength) {
            this.nombreInvalidoMsj = 'El nombre solo puede contener hasta 50 caracteres.';
          }
          if (this.$v.nombre.$error && !this.$v.nombre.required) {
            this.nombreInvalidoMsj = 'Debe ingresar el nombre del tipo de movimiento';
          }      
        } else {
          this.nombreValido = null;
          this.nombreInvalidoMsj = '';
        }
      }

      if (campo == 'abreviacion' || validarTodos) {
        if (this.$v.abreviacion.$error) {
          this.abreviacionValida = false;
          if (!this.$v.abreviacion.maxLength) {
            this.abreviacionInvalidaMsj = 'La abreviación solo puede contener hasta 5 caracteres.';
          }
        } else {
          this.abreviacionValida = null;
          this.abreviacionInvalidaMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let cuenta;
      let rubro;
      let subrubro;

      if (this.cuentaNombre) {
        cuenta = this.cuentas.find(cuenta => cuenta.nombre.trim() == this.cuentaNombre.trim());
      }
      if (cuenta && this.rubroNombre) {
          rubro = cuenta.rubros.find(rubro => rubro.nombre.trim() == this.rubroNombre.trim());
          if (rubro && this.subrubroNombre)  {
            subrubro = rubro.subrubros.find(subrubro => subrubro.nombre.trim() == this.subrubroNombre.trim());
          }
      }

      this.$store.dispatch('bancomovimientotipo/setCuenta', cuenta);
      this.$store.dispatch('bancomovimientotipo/setRubro', rubro);
      this.$store.dispatch('bancomovimientotipo/setSubrubro', subrubro);

      if (cuenta && !rubro) {
        if (cuenta.rubros) {
          if (cuenta.rubros.length != 0) {
            this.rubroValido = false;
            this.rubroInvalidoMsj = "Debe seleccionar un rubro";
            save = false;
          }
        }
      }
      if (rubro && !subrubro) {
        if (rubro.subrubros) {
          if (rubro.subrubros.length != 0) {
            this.subrubroValido = false;
            this.subrubroInvalidoMsj = "Debe seleccionar un subrubro";
            save = false;
          }
        }
      }

      let cuentaIngresosGastos;
      if (this.cuentaIngresosGastosNombre) {
        cuentaIngresosGastos = this.cuentasIngresosGastos.find(cuenta => cuenta.nombre.trim() == this.cuentaIngresosGastosNombre.trim());
      }
      this.$store.dispatch('bancomovimientotipo/setCuentaIngresosGastos', cuentaIngresosGastos);

      let interesBancarioRubro;
      if (this.interesBancarioRubroNombre) {
        interesBancarioRubro = this.interesesBancariosRubros.find(interesBancarioRubro => interesBancarioRubro.nombre.trim() == this.interesBancarioRubroNombre.trim());
      }
      this.$store.dispatch('bancomovimientotipo/setInteresBancarioRubro', interesBancarioRubro);

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        this.showSpinner();
        this.$store.dispatch('bancomovimientotipo/save')
          .then(()  => this.showModalMsj('Los cambios se registraron con éxito.', this.goList, this.goList, 'light'))
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner())
      } 
    },
    cuentaActualizada(cuentaNombre) {
      if (!this.loadingCuentas) {
        this.cuentaNombre = cuentaNombre;
        this.cuentaValida = null;
        this.cuentaInvalidaMsj = '';

        this.getRubros(true);
      }
    },
    rubroActualizado(rubroNombre) {
      if (!this.loadingCuentas) {
        this.rubroNombre = rubroNombre;
        this.rubroValido = null;
        this.rubroInvalidoMsj = '';
        this.getSubrubros(true);
      }
    },
    subrubroActualizado(subrubroNombre) {
      if (!this.loadingCuentas) {
        this.subrubroNombre = subrubroNombre;
        this.subrubroValido = null;
        this.subrubroInvalidoMsj = '';
      }
    },
    cuentaIngresosGastosActualizada(cuentaNombre) {
      this.cuentaIngresosGastosNombre = cuentaNombre;
      this.cuentaIngresosGastosValida = null;
      this.cuentaIngresosGastosInvalidaMsj = '';
    },
    interesBancarioRubroActualizado(interesBancarioRubroNombre) {
      this.interesBancarioRubroNombre = interesBancarioRubroNombre;
    },
    goBack() {
      this.$router.go(-1);
    },
    goList() {
      this.$router.push({ name: "BancosMovimientosTipos" });
    },
  },
  watch: {
  },
  validations: {
    nombre: {
      required,
      maxLength: maxLength(50)
    },
    abreviacion: {
      maxLength: maxLength(5)
    },
  },  
}
</script>

<style>
</style>
